import React from 'react';

class DemoHideabletext extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <div style={{display: this.props.visible ? 'block' : 'none'}}>
            {this.props.children}
        </div>
    )
  }
}

export default DemoHideabletext;